<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="multiple" :label="$lang.multiple" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="rounded" :label="$lang.rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="iconLeft" :disabled="loading" :label="$lang.iconLeft" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="iconRight" :disabled="loading" :label="$lang.iconRight" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="fancy" :label="$lang.fancy" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="disabled" :label="$lang.disabled" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="loading" :label="$lang.loading" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="flat" :label="$lang.flat" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col v-if="ready" equal-height :span="6" md12 sm12 xs24 v-for="(uploader, index) in uploaders" :key="index">
        <card full-height>
          <card-text>
            <upload
              @change="onChange"
              @reset="onReset"
              color="white"
              :block="block"
              :size="size"
              :flat="flat"
              :fancy="fancy"
              :icon-left="iconLeft ? uploader.icon : null"
              :icon-right="iconRight ? uploader.icon : null"
              :rounded="rounded"
              :label="$lang.browseForFile(uploader.type, multiple)"
              :plain="plain"
              :elevation="elevation"
              :bg-color="$root.colors.primary"
              :color-lightness="null"
              :icon-provider="iconProvider"
              :loading="loading"
              :multiple="multiple"
              :preview="preview"
              :preview-max-height="previewMaxHeight"
              :mime-types="uploader.mimeTypes"
              :max-file-size="maxFileSize"
              :bg-color-lightness="$root.colors.bgColorLightness"
              :disabled="disabled" />
          </card-text>
          <divider />
          <card-actions align="left">
            <container :class="['mb-2']">{{ $lang.maxFileSize }}: <code :pre="false" :class="['text-xs']">{{ format(maxFileSize) }}</code></container>
            <divider :class="['mt-2']" />
            <container :class="['my-2']">{{ $lang.multiple }}: <code :pre="false" :class="['text-xs']">{{ multiple }}</code></container>
            <divider :class="['mt-2']" />
            <container v-html="$lang.allowedMimeTypes" :class="['my-2']" />
            <code-chunk :pre="false" :class="['text-xs', 'block']">{{ uploader.mimeTypes }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageUpload',
  mixins: [
    methods
  ],
  data () {
    return {
      ready: false,
      uploaders: [],
      block: true,
      disabled: false,
      flat: false,
      fancy: false,
      rounded: true,
      plain: false,
      size: 'sm',
      iconLeft: true,
      iconRight: false,
      elevation: 'md',
      iconProvider: 'mdi',
      loading: false,
      multiple: true,
      preview: true,
      previewMaxHeight: 'unset',
      maxFileSize: 1572864
    }
  },
  watch: {
    multiple () {
      this.reset()
    },
    disabled () {
      this.reset()
    },
    fancy () {
      if (this.fancy) {
        this.rounded = false
      }
    },
    rounded () {
      if (this.rounded) {
        this.fancy = false
      }
    }
  },
  mounted () {
    this.getExternalData('upload.json', 'uploaders', 'get', () => {
      this.ready = true
    })
  },
  methods: {
    reset () {
      this.ready = false
      this.$nextTick(() => {
        this.ready = true
      })
    },
    onChange ($event) {
      this.log('change', 'upload', $event)
    },
    onReset ($event) {
      this.log('reset', 'upload', $event)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/forms/upload.vue